import React from "react";
import styles from "./Footer.module.css";
import { COMPANY_NAME, EMAIL, MAIL_LINK, WHATSAPP_DISPLAY, WHATSAPP_LINK } from "../siteData";

const YEAR = new Date().getFullYear();

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.brandCol}>
          <div className={styles.brand}>
            <span className={styles.brandMark}>JC</span>
            <span className={styles.brandName}>{COMPANY_NAME}</span>
          </div>
          <p className={styles.tagline}>
            Reliable cleaning and renovation for homes, offices, shops and
            other properties.
          </p>
        </div>

        <div className={styles.col}>
          <p className={styles.colTitle}>Quick Links</p>
          <a href="#home">Home</a>
          <a href="#services">Services</a>
          <a href="#about">About Us</a>
          <a href="#contact">Contact</a>
        </div>

        <div className={styles.col}>
          <p className={styles.colTitle}>Contact</p>
          <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer">
            {WHATSAPP_DISPLAY} (WhatsApp)
          </a>
          <a href={MAIL_LINK}>{EMAIL}</a>
        </div>
      </div>

      <div className={styles.bottom}>
        <div className="container">
          © {YEAR} {COMPANY_NAME}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
